<template>
    <div class="details-col">
        <div class="details-col__details">
            <!-- Organisation shows first if available -->
            <div v-if="account.organisation"
                 class="larger-detail">
                <i class="fa-solid fa-building"></i>
                <h6>{{ l('CUSTOMER_DETAILS.ORGANISATION') }}</h6>
                <p>{{ account.organisation }}</p>
            </div>

            <!-- If no organisation is available the name will be first and bigger.
             Otherwise the name is second and regular size. -->
            <div v-if="customerName"
                 :class="[account.organisation ? '' : 'larger-detail']">
                <i class="fa-solid fa-user"></i>
                <h6>{{ l('CUSTOMER_DETAILS.NAME') }}</h6>
                <p>{{ customerName }}</p>
            </div>

            <!-- Account reference -->
            <div>
                <i class="fa-solid fa-hashtag"></i>
                <h6>{{ l('MANAGE_ACCOUNT.ACCOUNT_REF') }}</h6>
                <p>{{ account.ref }}</p>
            </div>

            <!-- Account type -->
            <div>
                <i v-if="account.type === 'personal'"
                   class="fa-solid fa-user"></i>
                <i v-if="account.type === 'business'"
                   class="fa-solid fa-briefcase"></i>
                <h6>{{ l('CUSTOMER_DETAILS.ACCOUNT_TYPE') }}</h6>
                <p>{{ accountType }}</p>
            </div>

            <!-- Customer telephone -->
            <div v-if="account.primaryContact && account.primaryContact.tel">
                <i class="fa-solid fa-phone"></i>
                <h6>{{ l('CUSTOMER_DETAILS.TELEPHONE') }}</h6>
                <p>{{ account.primaryContact.tel }}</p>
            </div>

            <!-- Customer email -->
            <div v-if="account.primaryContact && account.primaryContact.email">
                <i class="fa-solid fa-envelope"></i>
                <h6>{{ l('CUSTOMER_DETAILS.EMAIL') }}</h6>
                <p>{{ account.primaryContact.email }}</p>
            </div>

            <!-- Customer address -->
            <div v-if="customerAddress">
                <i class="fa-solid fa-house"></i>
                <h6>{{ l('CUSTOMER_DETAILS.PRIMARY_ADDRESS') }}</h6>
                <p>{{ customerAddress }}</p>
            </div>
        </div>

        <div class="mt-1">
            <div class="btn-row">
                <AddAccountToCartButton :account="account"
                                        button-icon="fa-cart-shopping"
                                        button-text="CUSTOMER_DETAILS.CREATE_ORDER_WITH_ACCOUNT"
                                        data-analytics-id="Account Details / Add Account To Cart" />
            </div>

            <div class="btn-row">
                <SquareBtn v-if="showManageGoCardlessBtn"
                           @click="showManageGoCardless">
                    <i class="fa-solid fa-building-columns"></i> Manage Direct Debit
                </SquareBtn>
            </div>
        </div>
    </div>
</template>

<script>
import AddAccountToCartButton from './AddAccountToCartButton';
import PaymentMethodRef from '@/lib/PaymentMethods/PaymentMethodRef';
import SquareBtn from '@/vue/components/SquareBtn';
import { addressFilter } from '@/vue/filters/addressFilter';
import { contactNameFilter } from '@/vue/filters/contactNameFilter';
import { container } from '@/container';
import { MODAL_NAMES__EPOS } from '@/epos/vue/modals/MODAL_NAMES__EPOS';
import { ucfirstFilter } from '@/vue/filters/ucfirstFilter';

export default {
    components: { SquareBtn, AddAccountToCartButton },

    props: {
        /**
         * @type {CustomerAccount}
         */
        account: {
            type: Object,
            required: true,
        },
    },

    computed: {
        /**
         * @returns {string}
         */
        accountType() {
            return ucfirstFilter(this.account.type);
        },

        /**
         * @returns {string}
         */
        customerName() {
            return this.account.primaryContact ? contactNameFilter(this.account.primaryContact) : '';
        },

        /**
         * @returns {string}
         */
        customerAddress() {
            if (this.account.primaryAddress && !this.account.primaryAddress.isEmpty()) {
                return addressFilter(this.account.primaryAddress);
            }

            return '';
        },

        showManageGoCardlessBtn() {
            return container.paymentMethodService.getByRef(
                PaymentMethodRef.GOCARDLESS
            );
        },
    },

    methods: {
        addressFilter,

        showManageGoCardless() {
            container.vueModalFactory.openAndIgnoreResult(
                MODAL_NAMES__EPOS.MANAGE_GOCARDLESS,
                {
                    customerAccount: this.account,
                }
            );
        },
    },
};
</script>
